// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__JH4mZ","delete":"styles_delete__3Tmvq","update":"styles_update__dbsuE","add":"styles_add__1nWri"};